import { thunk, action } from 'easy-peasy'
import {  admin } from '../../../api/index'

export const sdocAdminModel = {
	adminSDOC: null,
	adminMESDOC: null,
	setAdminSDOC: action((state, adminSDOC) => {
		state.adminSDOC = adminSDOC
	}),
	setAdminMeSDOC: action((state, adminMESDOC) => {
		state.adminMESDOC = adminMESDOC;
	}),
	signInAdmin: thunk(async (actions, { username, password }) => {
		const res = await admin.signin(username, password, 2)
		let profile = null;

		if (res && res.status === 200) {
			const response = res.data
			if (response?.requiresTwoFactor || response?.requiresEnrollment) {
				return { res, profile, requiresTwoFactor: true, challenge: response };
			}

			actions.setAdminSDOC(response)
			profile = await actions.getAdminProfile()
		}
		return { res, profile };
	}),
	startTwoFactorEnrollment: thunk(async (actions, challengeToken) => {
		const res = await admin.startTwoFactorEnrollment(challengeToken)
		return res && res.status === 200 ? res.data : null
	}),
	verifyTwoFactor: thunk(async (actions, payload) => {
		const res = await admin.verifyTwoFactor(payload.challengeToken, payload.code)
		if (res && res.status === 200) {
			actions.setAdminSDOC(res.data)
			return res.data
		}
		return null
	}),
	confirmTwoFactorEnrollment: thunk(async (actions, payload) => {
		const res = await admin.confirmTwoFactorEnrollment(payload.challengeToken, payload.code)
		if (res && res.status === 200) {
			actions.setAdminSDOC(res.data)
			return res.data
		}
		return null
	}),
	signOutAdmin: thunk(actions => {
		actions.setAdminSDOC(null)
	}),
	getAdminProfile: thunk(async actions => {
		const res = await admin.me()
		if (res && res.status === 200) {
			actions.setAdminMeSDOC(res.data)
			return res.data
		}
		return null
	}),
}
